import { Country, Locale } from '@/i18n/i18nConfig.types';
import da from '@/i18n/locales/da.json';
import de from '@/i18n/locales/de.json';
import en from '@/i18n/locales/en.json';
import nl from '@/i18n/locales/nl.json';
import sv from '@/i18n/locales/sv.json';

export const defaultCountry: Country = Country.SE;

export const i18nConfig = {
  defaultLocale: Locale.sv,
  locales: [Locale.sv, Locale.en, Locale.da, Locale.de, Locale.nl],
} as const;

export const messages: Record<Locale, typeof en> = {
  sv,
  en,
  da,
  de,
  nl,
};

export const storyBookLanguages = [
  { value: Locale.sv, title: 'Svenska' },
  { value: Locale.en, title: 'English' },
  { value: Locale.da, title: 'Dansk' },
  { value: Locale.de, title: 'Deutsch' },
  { value: Locale.nl, title: 'Nederlands' },
];

export const getDefaultLanguageByCountry = (country: Country) => {
  switch (country) {
    case Country.DE:
      return Locale.de;
    case Country.SE:
      return Locale.sv;
    case Country.DK:
      return Locale.da;
    case Country.NL:
      return Locale.nl;
    default:
      return i18nConfig.defaultLocale;
  }
};
